import axios from "axios";
import { TOKEN_KEY } from "../constants/AppConstants";

const httpAuth = axios.create({
  baseURL: process.env.REACT_APP_AUTH_URI,
  auth: {
    username: "dovemed",
    password: "dovemed-rules",
  },
});

httpAuth.interceptors.request.use(function (config) {
  const token = localStorage.getItem(TOKEN_KEY);
  config.headers.BlogsAuthorization = token ? `Bearer ${token}` : "";
  return config;
});

export default httpAuth;
